/**
 * Central API / UI degradation reporting.
 * Uses Sentry in production; logs in development.
 */

import { captureException } from '../config/sentry'

export function reportError(err: unknown, ctx?: Record<string, unknown>): void {
  const normalized =
    err instanceof Error
      ? err
      : new Error(typeof err === 'string' ? err : JSON.stringify(err ?? 'unknown'))
  captureException(normalized, ctx ? { ...ctx } : undefined)
}
